import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67376232"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "thermo-footer" }
const _hoisted_4 = { class: "thermo-update-time" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "update-label" }, "更新时间：", -1))
const _hoisted_6 = { class: "update-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "thermo-wrap",
    ref: "wrapRef",
    style: _normalizeStyle(_ctx.wrapStyle)
  }, [
    _createElementVNode("div", {
      class: "thermo-gauge",
      style: _normalizeStyle(_ctx.gaugeStyle)
    }, [
      _createElementVNode("img", {
        class: "thermo-bg",
        src: _ctx.emptyTrackSrc,
        alt: "",
        draggable: "false"
      }, null, 8, _hoisted_1),
      (_ctx.hasFill)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "thermo-fill-slot",
            style: _normalizeStyle(_ctx.tubeStyle)
          }, [
            _createElementVNode("div", {
              class: "thermo-fill",
              style: _normalizeStyle(_ctx.fillStyle)
            }, null, 4)
          ], 4))
        : _createCommentVNode("", true),
      (_ctx.hasFill)
        ? (_openBlock(), _createElementBlock("img", {
            key: 1,
            class: "thermo-arrow-img",
            src: _ctx.arrowSrc,
            style: _normalizeStyle(_ctx.arrowStyle),
            alt: "",
            draggable: "false"
          }, null, 12, _hoisted_2))
        : _createCommentVNode("", true)
    ], 4),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", {
        class: "score",
        style: _normalizeStyle({ color: _ctx.accentColor })
      }, _toDisplayString(_ctx.displayScore), 5),
      _createElementVNode("span", {
        class: "pill",
        style: _normalizeStyle(_ctx.pillStyle)
      }, _toDisplayString(_ctx.stage.label), 5)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.updateTimeText), 1)
    ])
  ], 4))
}